import cn from 'classnames';

import { IConDefaultType } from '../types';

interface ITopIconProps extends IConDefaultType {}

function TopIcon({ color, className, size = 40, rotate, flip }: ITopIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="icon/top" filter="url(#filter0_d_4996_189443)">
          <path
            id="Path"
            d="M26 3C37.0457 3 46 11.9543 46 23C46 34.0457 37.0457 43 26 43C14.9543 43 6 34.0457 6 23C6 11.9543 14.9543 3 26 3Z"
            fill="#00C3DD"
          />
          <path
            id="icon_download"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.4 17.2351V33.5625C24.4 34.3564 25.1163 35 26 35C26.8837 35 27.6 34.3564 27.6 33.5625V17.2351L31.2686 20.7509C31.8935 21.3497 32.9065 21.3497 33.5314 20.7509C34.1562 20.1521 34.1562 19.1812 33.5314 18.5824L27.3334 12.6427C27.0468 12.2553 26.5566 12 26 12C25.4434 12 24.9532 12.2553 24.6666 12.6427L18.4686 18.5824C17.8438 19.1812 17.8438 20.1521 18.4686 20.7509C19.0935 21.3497 20.1065 21.3497 20.7314 20.7509L24.4 17.2351Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_4996_189443"
            x="0"
            y="0"
            width="52"
            height="52"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.764706 0 0 0 0 0.866667 0 0 0 0.30417 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4996_189443" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4996_189443" result="shape" />
          </filter>
        </defs>
      </svg>
    </i>
  );
}

export default TopIcon;
